import React,{useState} from 'react';
import {motion} from 'framer-motion'
import axios from 'axios';
import {useHistory, useLocation} from 'react-router-dom';


import './createTienda.css';
import URL from '../../../config/config-server-api'
import Alert from '../../../alert/alert';
import LoadComponent from '../../../utils/loadingComponent/loadingComponent';
import LoadingSendReceiveData from '../../../utils/loadingsendWithScreenLock/loadingSendWithScreenLock';
import CategoryAndSubcategory from '../../../utils/categoryAndSubcategory/categoryAndSubcategory';
import codeAreaPais from '../../../utils/codigosAreaPaises/codePaisAndTypemoneda.json';
import svgWhatsapp from '../../../../assets/whatsapp.svg'


const CreateTienda =({changeState})=>{
    
    
    const DataUser =JSON.parse(localStorage.getItem('dataUser'));
    console.log('local Storage');
    console.log(DataUser);

    const myRef = React.createRef();

    const history = useHistory();
    const location = useLocation();
    const [sizeForm, setSizeForm] = useState(2)

    const [ADanger, setAdDanger] = useState(false);
    
    const [loading, setLoading] = useState(false);
    const [ASucces, setASucces] = useState(false);
    const [AInfo, setAInfo] = useState(false);
    const [message, setMessage] = useState('');

    const [dataTienda, setDataTienda]  = useState({
        nombre: '',
        idClient : DataUser._id,
        nit: '',
        propietario: DataUser?.name +' '+DataUser?.lastName ??'',
        calle: '',
        telefono: '',
        callingCodes:'',
        country:{},
        departamento:'',
        description: '',
        flagCountry:'',
        category:'',
        subcategory:'',
        log: 0,
        lat: 0,
        logo: '',
        fotoLugar:''
    })


    const hanleChange=(e)=>{
        e.preventDefault();
        console.log(e.target.value)
        var aux = {
            ...dataTienda,
            [e.target.name]:e.target.value
        };

        if(e.target.name==='category' && e.target.value!=dataTienda.category  ){
            aux.subcategory = ''
        }
        setDataTienda({
            ...aux
        })
        console.log(dataTienda)
    }

    const handleContacData =(e)=>{
        console.log(e.target.value)
        var countrySlug = e.target.value;
        if(countrySlug==="")return;
        codeAreaPais.map((d,i)=>{
            if(countrySlug === d.slug){
                const country = {
                    name:d?.name,
                    slug:d?.slug,
                    flag:d?.flag,
                    callingCodes:d.callingCodes,
                    currenciesMoneda:d.currencies[0].symbol,
                    currenciesName:d.currencies[0].name,
                    currenciesSlug:d.currencies[0].slug
                }
                setDataTienda({
                    ...dataTienda,
                    country: country
                })

            }
        })

        

        // console.log(code)
        // console.log(country)
    }
    
    const showForm=()=>{
        console.log('show form')

        console.log(myRef.current.classList.toggle("hidden"))
        setSizeForm(1)
    }

    const sendData = async ()=>{
        console.log(dataTienda);

        const url = URL.UrlCreateNegocio;
        const config ={
            method:'POST',
            url:url,
            headers:{
                'Content-Type':'application/json'
            },
            data: JSON.stringify(dataTienda)
        }

        if(dataTienda.calle !='' &&
            dataTienda.categoria !='' &&
            dataTienda.description !='' &&
            dataTienda.idClient !='' &&
            dataTienda.departamento !='' &&
            // dataTienda.lat !='' &&
            // dataTienda.log !='' &&
            JSON.stringify(dataTienda.country) != '{}' &&
            dataTienda.nombre !='' &&
            dataTienda.propietario !='' &&
            dataTienda.telefono !=''
        ){
            
            setLoading(true);
            axios(config)
            .then(async(res)=>{
                console.log(res);
                if(res?.status===200){
                    console.log('tienda creada correctamente')
                    setMessage('Tienda online creada exitosamente');
                    setASucces(true);
                    const stateCreate = await res?.status; 
                    changeState(stateCreate);
                }
                setLoading(false)
            })
            .catch((err)=>{
                // console.log(err.response.data);
                if(err?.response?.status===400){
                    console.log(err.response)
                    console.log('error en el envios');

                    console.log(err?.response.data?.message)
                    setMessage((err?.response?.data?.message)? (err?.response?.data?.message):'Nombre del neogocio, tienda o servicio existente')
                    setLoading(false)
                    setAdDanger(true)
                }
            })

        }else{
        
            setMessage('Complete los campos requeridos');
            setAdDanger(true);

            
        }
    }

    const showAlertDanger =()=>{
        if(ADanger){
            setTimeout(()=>{
                setAdDanger(false)
            },5000)
            return <Alert className="" tipoAlert="danger" textAlert={message} />
        }
        // return <Alert tipoAlert="danger" textAlert="complete los campos requeridos" />
    }

    const showAlertInfo=()=>{
         if(AInfo){
            setTimeout(() => {
                setASucces(false)
            }, 5000);
            return <Alert tipoAlert="info" textAlert="compruebe que los datos sean conrrectos" />
         }
    }

    const showAlertSucces=()=>{
        if(ASucces){
           setTimeout(() => {
               setASucces(false)
           }, 5000);
           return <Alert tipoAlert="succes" textAlert={message} />
        }
   }

    const loadingSendData=()=>{
        if(loading){
            setTimeout(()=>{
                setLoading(false)
            },2000);
            return <motion.div  initial={{opacity:0, x:300}} animate={{opacity:1,x:0}}>
                <LoadingSendReceiveData></LoadingSendReceiveData>
            </motion.div>
        }
        
    }

    return(
        <div className="bg-gray-200 rounded-lg">
        
            <div>
                <header className="text-2xl font-bold p-2">Inicio</header>
                <div>
                    <section className="p-2 sm:p-3 lg:p-4">
                    En esta sección usted  podra crear una tienda online, todos los datos proporcionados serán tomados en cuenta al momento de otorgar la aceptación de la creación de la tienda. <br/>
                    <hr className=" my-4 sm:mt-2 text-green-300" style={{borderTop:'solid 1px'}} />
                    <p className="font-bold">Tome nota de las siguientes recomendaciones:</p>
                    <ul className="list-disc list-inside text-left">
                        <li>
                            Los datos proporcionados serán sujetos a verificación por parte de nuestro equipo. <br/>
                        </li>
                        <li>
                        Al momento de llenar el formulario verifique que el número de celular sea correcto, ya que sera a este numero de Whatsapp donde recibirá todos los detalles de la compra de productos/servicios. <br/>
                        </li>
                        <li>
                            Para poder crear la tienda solo debe hacer clic en el botón que indica “crear tienda”.
                        </li>
                    </ul>
                    </section>
                    <div  id="creanteContaner" className="pt-10 pb-10">
                        <div  href="#newTienda" 
                        onClick={()=>showForm()}
                        // onClick={()=>{window.location.reload(false)}}
                            className=" bg-gray-100 px-4 py-1 ml-3 mr-3 border text-black border-indigo-500 rounded-2xl hover:bg-indigo-500  hover:text-white font-bold" 
                        >
                         Crear Tienda <span> <i className=" fas fa-caret-down"></i> </span>
                         </div>

                        

                        {/* -- Drop-Down Form -- */}
                        <div ref={myRef} className="hidden form-create-tienda font-degradado" >
                        {showAlertDanger()}
                        {loadingSendData()}
                        {showAlertSucces()}
                        {showAlertInfo()}
                            <motion.div 
                                initial={{y:700, opacity:0}}
                                animate={{y:0,opacity:1}} transition={{duration:0.5}} 
                                id="newTienda"
                                className="ml-2 mr-2 sm:ml-10 sm:mr-10  lg:ml-auto lg:mr-auto lg:w-2/3  pt-5 pb-10"
                            >
                                <motion.form key={sizeForm} initial={{y:100, opacity:0}} animate={{y:0, opacity:1}}  action="#" className="bg-white spa grid grid-cols-1 px-5 pb-10 my-20 sm:px-10 rounded-md shadown-md">
                                    <div className="flex justify-end font-bold cursor-pointer pt-2" onClick={()=>{showForm();setSizeForm(2)}} style={{marginRight:'-2%'}}>X</div>
                                    <div className="text-gray-600 font-bold text-lg uppercase text-center py-3">Formulario de creación de una tienda online</div>
                                    
                                    <div className="flex flex-col block text-sm font-medium text-gray-700">
                                        <label htmlFor="nameTienda" htmlFor="#NombreDeLaTienda">Nombre de la tienda, negocio o servicio* : </label>
                                        <input name="nombre" onChange={(e)=>hanleChange(e)}  type="text" id="nameTienda" placeholder="Compumundo, PideloYa..."
                                        className="px-2 py-1 mt-1 focus:outline-none border focus:ring-green-500  focus:border-indigo-500 border-gray-300 rounded-md" ></input> <br/>
                                    </div>

                                    <div className="flex flex-col block text-sm font-medium text-gray-700">
                                        <label htmlFor="nameTienda" htmlFor="#NombreDeLaTienda">Categoria* <span className="text-gray-400">(A que tipo de categoria pertenece su servicio o producto)</span> : </label>
                                        <select onChange={(e)=>hanleChange(e)} name="category" id="" className="mt-1 block w-full py-1 mb-3 px-2 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                            <option value="" className="text-gray-200">Sin Seleccionar</option>
                                            {
                                                CategoryAndSubcategory.map((category,i)=>{
                                                    return <option key={category.slug} value={category.slug}>{category.name}</option>
                                                })
                                            }
                                           
                                        </select>
                                    </div>

                                    <div className="flex flex-col block text-sm font-medium text-gray-700">
                                        <label htmlFor="nameTienda" htmlFor="#NombreDeLaTienda">Subcategoria* <span className="text-gray-400">(A que tipo de subcategoria pertenece su servicio o producto)</span> : </label>
                                        <select onChange={(e)=>hanleChange(e)} name="subcategory" id="" className="mt-1 block w-full py-1 mb-3 px-2 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                            <option key="v-c" value="" className="text-gray-200">Sin Seleccionar</option>
                                            {
                                                dataTienda.category!=''?
                                                CategoryAndSubcategory.map((category,i)=>{
                                                        return category.slug===dataTienda.category?
                                                            category.subcategories.map((category2, i2)=>{
                                                                    return <option key={category2.slug} value={category2.slug}>{category2.name}</option>
                                                            })
                                                        :''
                                                
                                                }):''
                                            }
                                           
                                        </select>
                                    </div>

                                    <div className="flex flex-col block text-sm font-medium text-gray-700">
                                        <label htmlFor="nameTienda" htmlFor="#NombreDeLaTienda">Nit o lincencia de funcionamiento(Opcinonal): </label>
                                        <input name="nit" onChange={(e)=>hanleChange(e)} type="text" id="nameTienda" placeholder="6542234552345"
                                        className="px-2 py-1 mt-1 focus:outline-none border focus:ring-indigo-500  focus:border-indigo-500 border-gray-300 rounded-md" ></input> <br/>
                                    </div>

                                    <div className="flex flex-col block text-sm font-medium text-gray-700">
                                        <label htmlFor="nemePropietario" htmlFor="#NombreDeLaTienda">Nombre del propietario*: </label>
                                        <input name="propietario"  value={dataTienda.propietario} type="text" id="nemePropietario" placeholder="Pedro Aguilar, Marco Scarcha" 
                                        className="px-2 py-1 mt-1 focus:outline-none border focus:ring-indigo-500  focus:border-indigo-500 border-gray-300 rounded-md" ></input> <br/>
                                    </div>

                                    <div className="flex flex-col block text-sm font-medium text-gray-700">
                                        <label htmlFor="nameTienda" htmlFor="#NombreDeLaTienda">Pais ** {dataTienda.telefono<1?'':(/[0-9]{8}/.test(dataTienda.telefono)) && (dataTienda.telefono.toString().length)>=8 && (dataTienda.telefono.toString().length)<=13?<span className="text-green-400"> Número de Whatsapp correct</span>:<span className="text-red-600"> Número de Whatsapp correct</span>}: </label>
                                        <div className="flex flex-rows-1 mb-3">
                                            {dataTienda.country.flag?
                                                <img src={dataTienda.country.flag?dataTienda.country.flag:''} alt="a" className="h-6 w-8 my-auto mr-1 rounded-sm" />
                                            :''
                                            
                                            }
                                    
                                            <select name='callingCodes' onChange={(e)=>handleContacData(e)} className=" px-2 py-1 mt-1 focus:outline-none border focus:ring-indigo-500  focus:border-indigo-500 border-gray-300 rounded-md w-full" id="">
                                                <option value="">Sin seleccionar</option>
                                                {
                                                    codeAreaPais.map((d,i)=>{
                                                        return <option key={d.slug}  value={d.slug}>
                                                        {d.name}
                                                        </option>
                                                    })
                                                }
                                            </select>
                                        </div>
                        
                                    </div>

                                    <div className="flex flex-col block text-sm font-medium text-gray-700">
                                        <label htmlFor="nameTienda" htmlFor="#NombreDeLaTienda">Su número de Whatsapp ** {dataTienda.telefono<1?'':(/[0-9]{8}/.test(dataTienda.telefono)) && (dataTienda.telefono.toString().length)>=8 && (dataTienda.telefono.toString().length)<=13?<span className="text-green-400"> Numero de Whatsapp correct</span>:<span className="text-red-600"> Número de Whatsapp correct</span>}: </label>
                                            <div className="flex flex-rows-1 mb-3" >
                                            <img src={svgWhatsapp} alt="" />
                                            <select name='callingCodes' onChange={(e)=>handleContacData(e)} className=" focus:outline-none" id="">
                                                <option value={dataTienda.country.callingCodes}>+{dataTienda.country.callingCodes}</option>
                                                {/* {
                                                    codeAreaPais.map((d,i)=>{
                                                        return <option  value={d.callingCodes[0]} >+{d.callingCodes[0]}</option>
                                                    })
                                                } */}
                                            </select>
                                            <input name="telefono" onChange={(e)=>hanleChange(e)} type="number" id="nameTienda" placeholder="69551627" 
                                            className="px-2 py-1 mt-1 focus:outline-none border focus:ring-indigo-500  focus:border-indigo-500 border-gray-300 rounded-md" ></input> <br/>
                                        </div>
                                    </div>

                                    <div className="flex flex-col block text-sm font-medium text-gray-700">
                                        <label htmlFor="nameTienda" htmlFor="#NombreDeLaTienda">Departamento o Provincia <span className="text-gray-400"> </span> : </label>
                                        
                                        {
                                            dataTienda.country.slug ==='bolivia'?
                                                <select name="departamento" onChange={(e)=>hanleChange(e)} type="text" id="nameTienda" placeholder="Donde opera su negocio o emprendimiento" 
                                                className="px-2 py-1 mt-1 focus:outline-none border focus:ring-indigo-500  focus:border-indigo-500 border-gray-300 rounded-md" >
                                                    <option value="" className="">Sin Seleccionar</option> 
                                                    <option value="potosi">Potosi</option> 
                                                    <option value="chuquisaca">Chuquisaca</option>
                                                    <option value="santa cruz">Santa Cruz</option>
                                                    <option value="la paz">La Paz</option> 
                                                    <option value="oruro">Oruro</option> 
                                                    <option value="pando">Pando</option> 
                                                    <option value="tarija">Tarija</option> 
                                                    <option value="beni">Beni</option>
                                                    <option value="cochabamba">Cochabamba</option>
                                                    <option value="otros">Otros</option> 
                                                </select> 
                                            :
                                            <input name="departamento" onChange={(e)=>hanleChange(e)} type="text" id="nameTienda" placeholder="Donde opera su negocio o emprendimiento" 
                                                className="px-2 py-1 mt-1 focus:outline-none border focus:ring-indigo-500  focus:border-indigo-500 border-gray-300 rounded-md" >
                                            </input>
                                        }
                                    </div>

                                    <div className="flex flex-col block text-sm font-medium text-gray-700">
                                        <label htmlFor="nameTienda" htmlFor="#NombreDeLaTienda">Dirección*<span className="text-gray-400"> (Dirección Física o Punto de Entrega)</span> : </label>
                                        <input name="calle" onChange={(e)=>hanleChange(e)} type="text" id="nameTienda" placeholder="Calle Murillo #432" 
                                        className="px-2 py-1 mt-1 focus:outline-none border focus:ring-indigo-500  focus:border-indigo-500 border-gray-300 rounded-md" ></input> <br/>
                                    </div>

                    

             
                                    <div className="flex flex-col block text-sm font-medium text-gray-700">
                                        <label htmlFor="nameTienda" >Descripción* <span className="text-gray-400">(Que tipo de servicio o producto ofrece tu negocio)</span> : </label>
                                        <textarea name="description" onChange={(e)=>hanleChange(e)} type="text" id="nameTienda"  rows="7" colos="10" placeholder="Vendemos y exportamos computadoras y laptos con entrega a domicilio en toda la ciudad de ..."
                                        className="mt-1 focus:outline-none border focus:ring-indigo-500  focus:border-indigo-500 border-gray-300 rounded-md" ></textarea> <br/>
                                    </div>

                             

                                    <div onClick={()=>sendData()} className="bg-green-500 rounded-lg py-1 text-white font-bold mt-10 text-center cursor-pointer hover:bg-green-400">
                                        Aceptar
                                    </div>
                                    {/* {JSON.stringify(dataTienda)} */}

                                </motion.form>
                            </motion.div>
                        </div>

                    </div>
                </div>
            </div>
        </div>  
    );
}

export default CreateTienda;